import React from 'react'
import { formatPixeAtomic } from '../../lib/formatPixe'

export type WithdrawGate = {
  ok: boolean
  reason_code: 'OK' | 'FROZEN' | 'WITHDRAW_HOLD' | 'INSUFFICIENT_SETTLED' | string
  message: string | null
  available_to_withdraw_pixe: string
  pending_pixe: string
  withdraw_hold_until: string | null
  risk_level: 'LOW' | 'MEDIUM' | 'HIGH' | null
  frozen: boolean
  frozen_reason: string | null
}

function holdDate(iso: string | null): string {
  if (!iso) return ''
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
}

export default function WithdrawalStatusBanner({ gate, payoutsEnabled }: { gate: WithdrawGate; payoutsEnabled: boolean }) {
  const available = formatPixeAtomic(gate.available_to_withdraw_pixe)
  const pending = formatPixeAtomic(gate.pending_pixe)

  let tone = 'border-emerald-500/25 bg-emerald-500/10 text-emerald-100'
  let title = 'Withdrawals available.'
  let detail = `Available: ${available} PIXE`

  if (gate.frozen || gate.reason_code === 'FROZEN') {
    tone = 'border-red-500/30 bg-red-500/10 text-red-100'
    title = 'Withdrawals are temporarily disabled.'
    detail = gate.frozen_reason ? `Reason: ${gate.frozen_reason}` : 'Contact support to review your account.'
  } else if (gate.reason_code === 'WITHDRAW_HOLD') {
    tone = 'border-amber-500/30 bg-amber-500/10 text-amber-100'
    title = 'Withdrawals unlock after settlement.'
    detail = gate.withdraw_hold_until ? `Hold until: ${holdDate(gate.withdraw_hold_until)}` : 'Settlement hold is active.'
  } else if (gate.reason_code === 'INSUFFICIENT_SETTLED') {
    tone = 'border-amber-500/30 bg-amber-500/10 text-amber-100'
    title = 'No settled balance available yet.'
    detail = pending === '0' ? 'Buy PIXE / earn more before withdrawing.' : `Pending settlement: ${pending} PIXE`
  }

  return (
    <div className={`rounded-xl border p-4 ${tone}`}>
      <div className="text-sm font-semibold">Withdrawal status</div>
      <div className="mt-1 text-sm font-semibold">{title}</div>
      <div className="mt-1 text-sm">{detail}</div>
      <div className="mt-2 text-xs opacity-90">
        Available to withdraw: {available} PIXE
        {` | `}
        Pending: {pending} PIXE
        {gate.risk_level ? ` | Risk: ${gate.risk_level}` : ''}
      </div>
      {!payoutsEnabled ? <div className="mt-2 text-xs">Connect Stripe to enable withdrawals.</div> : null}
      <div className="mt-2 text-[11px] opacity-80">1 PIXE = $1 (current internal peg).</div>
    </div>
  )
}
